// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';
import playerService from '@/entities/player/player-service';

export default {
  createAllPlayers(playerList, loggedUser) {

    return new Promise((resolve, reject) => {

      var count = 0
      playerList.forEach(player => {
        
        playerService
        .save(player, loggedUser)
        .then(() => {
          if( count == playerList.length - 1){
            resolve()
          } 
          count = count + 1
        }).catch((error) => {
          reject(error)
        })
      });
    })
  }
};



// WEBPACK FOOTER //
// ./src/entities/player/player-import/player-import-service.js